import React, { useState, useEffect } from 'react';

const API_URL = (process.env.REACT_APP_API_URL || '').trim().replace(/\/+$/, '');

export default function DistributorDashboard({ token, onAssignLearners, onDeploy }) {
  const [lessons, setLessons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [collapsed, setCollapsed] = useState(false);

  const fetchReady = () => {
    if (!token) return;
    fetch(`${API_URL}/distributor/ready-to-deploy`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(r => r.json())
      .then(data => {
        if (data.success) setLessons(data.lessons);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    fetchReady();
    const interval = setInterval(fetchReady, 15000); // poll every 15s
    return () => clearInterval(interval);
  }, [token]);

  if (lessons.length === 0 && !loading) return null;

  if (collapsed) return (
    <div style={{ position: 'fixed', bottom: '24px', right: '80px', zIndex: 200 }}>
      <button
        onClick={() => setCollapsed(false)}
        style={{
          width: '52px', height: '52px', borderRadius: '50%',
          background: '#10b981', border: 'none', cursor: 'pointer',
          color: '#fff', fontSize: '22px',
          boxShadow: '0 4px 12px rgba(16,185,129,0.4)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          position: 'relative',
        }}
        title="Ready to Deploy"
      >
        🚀
        {lessons.length > 0 && (
          <span style={{
            position: 'absolute', top: -4, right: -4,
            background: '#ef4444', color: '#fff', borderRadius: '50%',
            width: '20px', height: '20px', fontSize: '10px', fontWeight: 700,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            {lessons.length}
          </span>
        )}
      </button>
    </div>
  );

  return (
    <div style={{
      position: 'fixed', bottom: '24px', right: '80px', zIndex: 200,
      width: '360px', background: '#fff', borderRadius: '16px',
      boxShadow: '0 8px 32px rgba(0,0,0,0.15)', overflow: 'hidden',
    }}>
      {/* Header */}
      <div style={{
        background: '#10b981', padding: '14px 16px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      }}>
        <div>
          <div style={{ fontWeight: 700, color: '#fff', fontSize: '14px' }}>🚀 Ready to Deploy</div>
          <div style={{ fontSize: '11px', color: '#d1fae5' }}>
            {lessons.length} lesson{lessons.length !== 1 ? 's' : ''} approved
          </div>
        </div>
        <button
          onClick={() => setCollapsed(true)}
          style={{ background: 'none', border: 'none', color: '#d1fae5', cursor: 'pointer', fontSize: '16px' }}
        >✕</button>
      </div>

      {/* Lessons list */}
      <div style={{ maxHeight: '400px', overflowY: 'auto', padding: '8px' }}>
        {loading ? (
          <div style={{ padding: '16px', color: '#94a3b8', textAlign: 'center', fontSize: '13px' }}>Loading...</div>
        ) : (
          lessons.map(lesson => (
            <div key={lesson.template_id} style={{
              background: '#f8fafc', borderRadius: '10px', padding: '14px',
              marginBottom: '8px', borderLeft: '3px solid #10b981',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                <span style={{ fontWeight: 700, fontSize: '13px', color: '#0f172a' }}>{lesson.name}</span>
                {lesson.is_assessment && (
                  <span style={{ padding: '2px 8px', borderRadius: '12px', fontSize: '10px', fontWeight: 700, background: '#6366f1', color: '#fff' }}>📝 Assessment</span>
                )}
              </div>
              {lesson.approved_at && (
                <div style={{ fontSize: '11px', color: '#94a3b8', marginBottom: '10px' }}>
                  ✅ Approved {new Date(lesson.approved_at).toLocaleDateString()}
                </div>
              )}
              <div style={{ display: 'flex', gap: '8px' }}>
                <button
                  onClick={() => onAssignLearners(lesson)}
                  style={{
                    flex: 1, padding: '7px', background: '#eef2ff', color: '#4f46e5',
                    border: 'none', borderRadius: '6px', fontSize: '12px',
                    fontWeight: 600, cursor: 'pointer',
                  }}
                >
                  🎓 Assign Learners
                </button>
                <button
                  onClick={() => onDeploy(lesson)}
                  style={{
                    flex: 1, padding: '7px', background: '#10b981', color: '#fff',
                    border: 'none', borderRadius: '6px', fontSize: '12px',
                    fontWeight: 600, cursor: 'pointer',
                  }}
                >
                  🚀 Deploy
                </button>
                <button
  onClick={() => {
    fetch(`${API_URL}/board/templates/${lesson.template_id}/export/scorm`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(r => {
        if (!r.ok) throw new Error('Export failed');
        return r.blob();
      })
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${lesson.template_id}-scorm.zip`;
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(err => alert('SCORM export failed: ' + err));
  }}
  style={{
    flex: 1, padding: '7px', background: '#6366f1', color: '#fff',
    border: 'none', borderRadius: '6px', fontSize: '12px',
    fontWeight: 600, cursor: 'pointer',
  }}
>
  📦 Download SCORM
</button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
